import Routes from './Routes';
export default Routes;

export * from './paths';
